const MessageType = {
    'SUCCESS': "SUCCESS",
    'ERROR': "ERROR",
    'WARNING': 'WARNING'
}


module.exports = {
    MessageType
}